import { Tab, TabList } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'

export const CustomTabList = forwardRef(({ items = [], ...rest }, ref) => {
  return (
    <TabList
      borderBottom="1px"
      zIndex={9}
      ref={ref}
      {...rest}
    >
      <>
        {items.map(item => {
          return (
            <Tab
              key={item.id}
              fontSize="14px"
              color="brand.textGray"
              pb="6px"
              disabled={item.disabled}
              _selected={{
                borderBottom: '2px solid',
                borderColor: 'black',
                borderRadius: '2px',
                color: 'black',
              }}
              _active={{
                backgroundColor: 'transparent',
              }}
            >
              {item.label}
            </Tab>
          )
        })}
      </>
    </TabList>
  )
})

CustomTabList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
}
